@let data = pageData$ | async;
<glxy-page [pagePadding]="false">
  <ng-container *ngIf="data && !isLoading; else loadingSpinner">
    <glxy-page-toolbar>
      <glxy-page-nav>
        <glxy-page-nav-button
          *ngIf="namespace$ | async as namespace"
          [previousPageTitle]="'INTEGRATION_PAGE.PLATFORM_INTEGRATION' | translate"
          [historyBackButtonTitle]="'INTEGRATION_PAGE.PLATFORM_INTEGRATION' | translate"
          [previousPageUrl]="navigateBack()"
        ></glxy-page-nav-button>
      </glxy-page-nav>
      <glxy-page-title>{{ 'INTEGRATION_PAGE.PLATFORM_INTEGRATION' | translate }}</glxy-page-title>
    </glxy-page-toolbar>
    <ng-container *ngIf="data.cardDetail?.integration; else pageNotFound">
      <div class="mp-container bg-color">
        <div class="left-space"></div>
        <div class="marketing-page-content" *ngIf="pageData$ | async as data">
          <div class="marketing-page-title-padding"></div>
          <div class="header-container">
            <div class="logo-container">
              <div class="logo">
                <img [src]="data.cardDetail?.integration.logo" alt="Logo" />
              </div>
            </div>
            <div class="header-info-container">
              <div class="title-tag-container">
                <div class="title">{{ data.cardDetail?.integration.displayName }}</div>
                <div class="connection-badge-container" *ngIf="cards$ | async as cards">
                  <div *ngIf="cards?.length && cards[0].status === connectionStatus.CONNECTED">
                    <glxy-badge class="connection-badge" [color]="'green'">{{
                      'INTEGRATION_CARD.CONNECTED' | translate
                    }}</glxy-badge>
                  </div>
                </div>
                <div>
                  <glxy-badge [color]="'yellow'" *ngIf="connection_status === connectionStatus.PRECONNECTED">
                    {{ 'INTEGRATION_CARD.CONNECTION_PENDING' | translate }}
                  </glxy-badge>
                </div>
              </div>
              <div class="description">{{ data.cardDetail?.integration.description }}</div>
            </div>

            <div class="connection-badge-container-mobile" *ngIf="cards$ | async as cards">
              <div *ngIf="cards?.length && cards[0].status === connectionStatus.CONNECTED">
                <glxy-badge class="connection-badge-mobile" [color]="'green'">{{
                  'INTEGRATION_CARD.CONNECTED' | translate
                }}</glxy-badge>
              </div>
            </div>
            <ng-container class="button-container">
              <div *ngFor="let button of data | buttonConfigPipe" class="button-margin">
                <platform-integration-button-template
                  [buttonModel]="button"
                  class="button-class"
                  (click)="buttonAction(data, button?.action, button?.isDisabled)"
                ></platform-integration-button-template>
                @if (button?.isDisabled && button?.toolTipMessage) {
                  <mat-icon
                    [glxyTooltip]="
                      button?.toolTipMessage | translate: { integrationName: data.cardDetail?.integration?.displayName }
                    "
                    [highContrast]="false"
                    class="info-icon smb-mat-icon"
                  >
                    info_outline
                  </mat-icon>
                }
              </div>
            </ng-container>

            <div class="space-button"></div>
          </div>
          <div class="marketing-page-title-padding"></div>
        </div>
        <div class="right-button-space"></div>
      </div>
      <div class="line-divider">
        <mat-divider></mat-divider>
      </div>
      <div class="mp-container">
        <div class="left-space"></div>
        <div class="marketing-page-content" *ngIf="pageData$ | async as data">
          <div class="connected-cards-container" *ngIf="cards$ | async as cards">
            <div *ngIf="cards?.length">
              <div class="card-container">
                <div class="connection-title">{{ 'INTEGRATION_CARD.CONNECTED_ACCOUNTS' | translate }}</div>
                <div class="preconnect-alert" *ngIf="connection_status === connectionStatus.PRECONNECTED">
                  <glxy-alert type="info">
                    <span [innerHTML]="marketingPreconnectMessage(data.cardDetail)"></span>
                  </glxy-alert>
                </div>
                <div class="row">
                  <div class="marketing-integration-card-container w-100" *ngFor="let card of cards">
                    <platform-integration-card
                      class="connection-card"
                      [integration]="card.integration"
                      [connection]="card"
                      [user]="card.userInfo"
                      [tab]="userAction.MANAGE"
                    ></platform-integration-card>
                  </div>
                </div>
              </div>
              <div class="line-divider">
                <mat-divider></mat-divider>
              </div>
            </div>
          </div>
          <div class="additional-info-container">
            <div
              class="dynamic-long-description-container"
              [innerHTML]="data.cardDetail?.integration.longDescription | iTrustThisHtml"
            ></div>

            <div class="more-info-container">
              <div class="main-title">Details</div>
              <div class="sub-title">Categories</div>
              <div class="info">{{ data.cardDetail?.integration.additionalInfo.categories.join(', ') }}</div>
              <div *ngIf="data.cardDetail">
                <ng-container
                  *ngIf="
                    data.cardDetail.integration?.additionalInfo?.websites &&
                    data.cardDetail.integration.additionalInfo.websites.length
                  "
                >
                  <ng-container *ngFor="let website of data.cardDetail.integration.additionalInfo.websites">
                    <a [href]="website.siteUrl" target="_blank">
                      Website
                      <mat-icon class="icon-open-link">open_in_new</mat-icon>
                    </a>
                  </ng-container>
                </ng-container>
              </div>
              <div class="line-divider">
                <mat-divider></mat-divider>
              </div>
              <div class="main-title">Requirements</div>
              <div class="info">
                You'll need:
                <ul class="req_list">
                  <li *ngIf="data.cardDetail?.integration?.additionalInfo?.requirements">
                    <span *ngFor="let requirement of data.cardDetail?.integration?.additionalInfo?.requirements">
                      {{ requirement }}
                    </span>
                  </li>
                </ul>
              </div>
              <div class="line-divider">
                <mat-divider></mat-divider>
              </div>

              <div *ngIf="data.cardDetail?.integration?.additionalInfo?.resources" class="main-title">
                Resources
                <platform-integration-resources
                  [resources]="data.cardDetail.integration.additionalInfo.resources"
                ></platform-integration-resources>
                <div class="line-divider"><mat-divider></mat-divider></div>
              </div>
              <platform-integration-works-with
                [worksWithData]="data.cardDetail?.integration?.additionalInfo?.worksWith"
              ></platform-integration-works-with>
              <div class="sub-title" *ngIf="data.cardDetail?.integration?.additionalInfo?.productIds?.length > 0">
                Products
              </div>
              <div *ngIf="productInfo$ | async as productInfo">
                <div *ngFor="let product of productInfo" class="product-item">
                  <img [src]="product.iconUrl" alt="{{ product.name }}" class="product-icon" />
                  <span class="product-name">{{ product.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right-space"></div>
      </div>
    </ng-container>
  </ng-container>
  <ng-template #pageNotFound>
    <platform-integration-not-found> </platform-integration-not-found>
  </ng-template>
  <ng-template #loadingSpinner>
    <glxy-loading-spinner></glxy-loading-spinner>
  </ng-template>
</glxy-page>
